export const newManufacturer = {
  attributes: {
    name: '',
  },
}
